import React, { useEffect, useState } from 'react';
import { CubeIcon } from '@heroicons/react/24/outline';
import StaffShell from '../../StaffShell';
import staffApi, { apiError } from '../../api';
import { SkeletonRows } from '../../components/Skeleton';

export default function Inventory() {
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    staffApi.get('/materials/')
      .then((r) => setMaterials(r.data))
      .catch((err) => setError(apiError(err)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <StaffShell backTo="/staff/app" max="max-w-2xl">
      <div className="flex items-center gap-2 mb-1">
        <CubeIcon className="h-6 w-6 text-lime" />
        <h1 className="text-white text-2xl sm:text-3xl font-extrabold">Inventory</h1>
      </div>
      <p className="text-white/60 text-sm mb-6">
        Stock auto-decrements as technicians log materials. Negative means the count has fallen behind.
      </p>
      {error && <p className="text-red-300 text-sm mb-4">{error}</p>}

      {loading ? (
        <SkeletonRows rows={6} />
      ) : (
        <div className="space-y-2">
          {materials.map((m) => (
            <div key={m.id} className="flex items-center justify-between rounded-2xl border border-line bg-surface px-4 py-3">
              <div>
                <div className="text-ink font-semibold">{m.name}</div>
                <div className="text-ink-soft text-xs">{m.unit}</div>
              </div>
              <div className={`text-xl font-extrabold ${m.current_stock < 0 ? 'text-red-500' : 'text-ink'}`}>
                {m.current_stock}
              </div>
            </div>
          ))}
        </div>
      )}
    </StaffShell>
  );
}
